import React from 'react';
import { View } from 'react-native';
import Logo from 'design-system/Logo';
const RewardLogo = ({ data, style }) => (<View style={style}>
    <Logo R44 uri={data.partner.iconUrl && data.partner.iconUrl !== "''"
        ? data.partner.iconUrl
        : data.imageUrl}/>
  </View>);
export default RewardLogo;
